// removed by extract-text-webpack-plugin
module.exports = {"container":"_3B0Al2YviK4O8u9z9taxex","overlay":"_1raj3pXf1Hiq8x8w7r9QAc","header":"_2LN9U-G0GYffGWmeU5RNR5","text":"_2d733KiGi4SrH37kDyQqnh","info":"_180-H0gWNqbmKpzqDsz07H","scrollingArea":"D2_YEgo3tXJ6HLu6U36en","closeButton":"_3jP0c60SPEGbpdrQn6tRGV","spinner":"_160eWvbq_JnJTdfmUZDZbk"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutNotice/style.scss
// module id = 935
// module chunks = 0